import type { ModernSubscription } from '../../types';

import { isInvoiced } from './isInvoiced';

export function isSelfServe(modernSubscription: ModernSubscription) {
  return !isInvoiced(modernSubscription);
}
